export const getMessageId = (message) => message && (message.id || message.uuid);

export const mergeUniqueMessages = (...messageGroups) => {
  const seenIds = new Set();
  const messages = [];

  messageGroups.forEach((group) => {
    (Array.isArray(group) ? group : []).forEach((message) => {
      const id = getMessageId(message);
      if (id && seenIds.has(id)) return;
      if (id) seenIds.add(id);
      messages.push(message);
    });
  });

  return messages;
};
